function e(e){return e!==void 0}export{e as isDefined};
//# sourceMappingURL=isDefined-D96LKBI6.js.map